import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";

const schema = yup
  .object({
    title: yup.string().required("This field is required"),
    name: yup.string().required("This field is required"),
    iban: yup.string().required("This field is required"),
    ntn: yup.string().required("This field is required"),
    status: yup.boolean(),
  })
  .required();

const AddBank = ({ data, setStoreInformationData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  let user = JSON.parse(localStorage.getItem("user"));

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
      sellerId: user?.id,
    };

    // console.log(myData);

    // try {
    //   if (location?.state) {
    //     setLoading(true);
    //     await BanksAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Bank updated successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   } else {
    //     setLoading(true);
    //     await BanksAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Bank created successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   }

    //   // ------- Get all object keys form data and set empty values to reset ------------
    //   const keys = Object.keys(data);
    //   for (const key of keys) {
    //     submittedValues[key] = "";
    //   }
    //   reset({ ...submittedValues });
    //   navigate(-1);
    // } catch (error) {
    //   toast.error("Something went wrong", {
    //     position: customSettings.toastPosition,
    //     autoClose: customSettings.toastClose,
    //   });
    //   console.log(error);
    // }
  };

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [setValue]);

  return (
    <>
      <FormProvider {...methods}>
        <div className="d-flex justify-content-end">
          <Button
            variant="link"
            className="text-secondary py-2 fw-medium"
            style={{ paddingRight: "20px" }}
            type="button"
            onClick={() => setStoreInformationData(null)}
          >
            Cancel
          </Button>
        </div>

        <BasicInformation />
      </FormProvider>
    </>
  );
};

export default AddBank;

//  <Card.Header className="border-bottom">
//               <Row className="flex-between-center ">
//                 <Col md>
//                   {/* <BreadCrumbTable
//                     title={LOCAL_STORAGE_USER?.name || "Sellers"}
//                     subTitle="Bank Accounts"
//                     subSubTitle={location?.state?.name}
//                   /> */}
//                   {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                     {" "}
//                     Libraries | Weighment Indicators
//                   </h5> */}
//                 </Col>
//                 <Col xs="auto"></Col>
//               </Row>
//             </Card.Header>
